import { registerLocale, setDefaultLocale } from "react-datepicker";

import { dateFnsLocalesMap } from "./dateFnsLocaleMap";

export const initLocale = (localeString: string) => {
  const localeObject = dateFnsLocalesMap[localeString];

  if (localeObject) {
    // React Date Picker
    registerLocale(localeString, localeObject);
    setDefaultLocale(localeString);
  }

  return localeObject;
};
